import { useCallback, useState } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { BookmarkPromptIcon } from 'src/assets/icons/BookmarkPromptIcon';
import { ImproveIcon } from 'src/assets/icons/ImproveIcon';
import {
  CUSTOM_BUTTON_SIZE,
  CUSTOM_BUTTON_VARIANT,
  CustomButton,
} from 'src/components/CustomButton';
import { CustomTooltip } from 'src/components/CustomTooltip';
import { Loader } from 'src/components/Loader';
import { PROMPT_ACTION, SUGGEST_PROMPT_TYPES } from 'src/data/prompt';

import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  isSuggestPromptLoading: PropTypes.bool,
  showImprovePrompt: PropTypes.bool,
  showSaveButtonIconOnly: PropTypes.bool,
  improvePromptTooltip: PropTypes.string,
  improvePromptCaption: PropTypes.string,
  onAction: PropTypes.func.isRequired,
  isEmpty: PropTypes.bool,
};

const defaultProps = {
  className: '',
  isSuggestPromptLoading: false,
  showImprovePrompt: false,
  showSaveButtonIconOnly: false,
  improvePromptTooltip: null,
  improvePromptCaption: null,
  isEmpty: false,
};

export const Actions = ({
  className,
  isSuggestPromptLoading,
  showImprovePrompt,
  showSaveButtonIconOnly,
  improvePromptTooltip,
  improvePromptCaption,
  onAction,
  isEmpty,
}) => {
  const styles = useStyles();

  const [loadingType, setLoadingType] = useState(null);
  const saveButtonLabel = showSaveButtonIconOnly ? '' : 'Save';

  const handleSave = useCallback(() => {
    onAction(PROMPT_ACTION.savePrompt);
  }, [onAction]);

  const handleImproveClick = useCallback(() => {
    setLoadingType(SUGGEST_PROMPT_TYPES.improve);
    onAction(PROMPT_ACTION.suggestPrompt, { type: SUGGEST_PROMPT_TYPES.improve });
  }, [onAction]);

  return (
    <div className={cx(styles.root, className)}>
      {showImprovePrompt && (
        <CustomTooltip
          classes={{ tooltip: styles.tooltip }}
          title={improvePromptTooltip || 'Improve prompt with AI'}
          placement="bottom"
          arrow
        >
          <CustomButton
            className={styles.button}
            classes={{ startIcon: styles.startIcon }}
            variant={CUSTOM_BUTTON_VARIANT.text}
            size={CUSTOM_BUTTON_SIZE.smaller}
            onClick={handleImproveClick}
            startIcon={
              isSuggestPromptLoading && loadingType === SUGGEST_PROMPT_TYPES.improve ? (
                <Loader size={16} />
              ) : (
                <ImproveIcon />
              )
            }
            disabled={isEmpty || isSuggestPromptLoading}
          >
            {improvePromptCaption || 'Improve'}
          </CustomButton>
        </CustomTooltip>
      )}

      <CustomTooltip
        classes={{ tooltip: styles.tooltip }}
        title="Save prompt"
        placement="bottom"
        arrow
      >
        <CustomButton
          className={styles.button}
          classes={{ startIcon: styles.startIcon }}
          variant={CUSTOM_BUTTON_VARIANT.text}
          size={CUSTOM_BUTTON_SIZE.smaller}
          onClick={handleSave}
          startIcon={<BookmarkPromptIcon />}
          disabled={isEmpty}
        >
          {saveButtonLabel}
        </CustomButton>
      </CustomTooltip>
    </div>
  );
};

Actions.propTypes = propTypes;
Actions.defaultProps = defaultProps;
